import React, {useState} from 'react';
import ArrWaitToCompleteModal from '../../../components/common/arr-wait-to-complete-modal/ArrWaitToCompleteModal';
import {Box} from '@mui/material';
import ArrButton from '../../../components/common/arr-button/ArrButton';

const WaitToCompleteModal: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <Box>
      <ArrButton
        onClick={() => setShowModal(true)}
        disabled={showModal}
        dataTestId="wait-to-complete-modal-show-modal-button">
        Show Modal
      </ArrButton>
      <ArrWaitToCompleteModal reportComplete={false} showModal={showModal} />
    </Box>
  );
};

export default WaitToCompleteModal;
